import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { components as selectComponents } from "react-select";
import AsyncSelect from "react-select/lib/Async";

import { TTP_API_URL } from "Config";
import { fetchUsersSuggestions } from "Thunks";

import { selectStyle, avatarStyle, singleValueStyle } from "./ReactSelectStyle";

import _ from "i18n";

const Input = props => {
  if (props.isHidden) {
    return <selectComponents.Input {...props} />;
  }
  return (
    <div>
      <selectComponents.Input {...props} />
    </div>
  );
};

const SingleValue = ({ children, ...props }) => {
  const { avatarUrl, firstName } = props.data;

  return (
    <selectComponents.SingleValue {...props}>
      <div style={singleValueStyle()}>
        {" "}
        <span style={avatarStyle(avatarUrl && `url('${avatarUrl}')`)}>
          {" "}
          {!avatarUrl && firstName && firstName.charAt(0)}
        </span>
        {children}
      </div>
    </selectComponents.SingleValue>
  );
};

const Option = props => {
  const { children, ...rest } = props;
  const { avatarUrl, firstName } = rest.data;

  const withAvatarChildren = (
    <div style={singleValueStyle()}>
      <span style={avatarStyle(avatarUrl && `url('${avatarUrl}')`)}>
        {!avatarUrl && firstName && firstName.charAt(0)}
      </span>
      {children}
    </div>
  );

  return <selectComponents.Option {...rest} children={withAvatarChildren} />;
};

export class UsersSelect extends PureComponent {
  loadUsersSuggestions = inputValue => {
    return this.props
      .fetchUsersSuggestions({ search: inputValue })
      .then(result => result.value.data.data);
  };

  render() {
    const { user, onChange } = this.props;

    return (
      <AsyncSelect
        value={user}
        onChange={onChange}
        loadOptions={this.loadUsersSuggestions}
        defaultOptions={true}
        getOptionLabel={option => `${option.firstName} ${option.lastName}`}
        getOptionValue={option => option.id}
        components={{ Option, SingleValue, Input }}
        placeholder={_("Select user...")}
        classNamePrefix="media-user-select"
      />
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = dispatch => ({
  fetchUsersSuggestions: options => dispatch(fetchUsersSuggestions(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersSelect);



// WEBPACK FOOTER //
// ./src/components/Common/UsersSelect.js